module.exports = __webpack_public_path__ + "img/full-08.83ffa19c.png";